export default function useErrorToast(message: string, life: number = 5000): void {
  const nuxtApp = useNuxtApp()
  const { $toast } = nuxtApp
  const { t } = nuxtApp.$i18n

  $toast.add({
    severity: 'error',
    summary: 'Error',
    detail: t(message),
    life: life,
  })
}
